export default class splashManager {
    constructor(){

        TweenMax.set(document.getElementById('l-splash'),{
            opacity: 1,
        });

        //tweenmax timeline
        this.tl = new TimelineMax();

        //status
        this.status = {
            done:false,
            progress:0,
        }

    }
    init(_displayType){
        //dom
        this.$kv = document.getElementById('l-kv');
        this.$splash = document.getElementById('l-splash');
        this.$bg = document.getElementById('l-splash-bg');
        this.$hello = document.getElementById('l-splash-hello');
        if(_displayType == 'sp') {
            this.$helloBg = document.querySelector('#l-splash-hello-bg-sp');
            this.$helloText = document.querySelector('#l-splash-hello-text-sp');
        }else{
            this.$helloBg = document.querySelector('#l-splash-hello-bg');
            this.$helloText = document.querySelector('#l-splash-hello-text');
        }
        this.$helloCover= document.querySelector('#l-splash-hello .bg');
        this.$progress = document.querySelector('#l-splash-progress');
        this.$now = document.querySelector('#l-splash-progress .now');
        this.$and = document.querySelector('#l-splash-and');
        this.$andBg = document.querySelector('#l-splash-and .bg');
        this.$done = document.querySelector('#l-splash-done');

        TweenMax.set(this.$kv,{
            display: 'none',
        });
    }
    done(){ //ロード完了時
        this.status.done = true;
        this.$now.innerText = 100;
        this.start();
    }
    start(){ //アニメーションスタート
        this.tl.to(this.$progress,0.5,{
            delay:0.2,
            scale : .7,
            opacity:0,
            display:'none',
            ease : Sine.easeInOut,
            onStart:() => {
                TweenMax.to(this.$andBg,.6, {
                    delay:0.45,
                    x: '100%',
                    ease: Sine.easeInOut
                });
            }
        }).to(this.$helloCover,.9, {
            delay:0.6,
            x: '100%',
            ease: Sine.easeInOut,
            onStart: () => {
                TweenMax.fromTo(this.$helloText,.6, {
                    x: -150
                },{
                    x: 0,
                    ease: Sine.easeInOut
                });
            }
        }).set(this.$bg,{
            css:{
                'background-color':'#fff'
            }
        }).set(this.$helloText,{
            display: 'none',
        }).set(this.$helloBg,{
            visibility: 'visible',
            opacity:1
        }).set(this.$kv,{
            display: 'block',
        }).to(this.$bg,.6, {
            display: 'none',
            opacity: 0,
            ease: Sine.easeInOut,
            onStart:() => {
                TweenMax.to(this.$and,.3, {
                    scale : .7,
                    opacity:0,
                    display:'none',
                    ease : Sine.easeInOut
                });
            }
        }).to(this.$hello,.3, {
            delay : .2,
            scale : 4.2,
            opacity:0,
            display:'none',
            ease : Sine.easeInOut
        }).fromTo(this.$done,.35, {
            y:50,
        },{
            delay : .5,
            y:0,
            visibility: 'visible',
            opacity:1,
            ease : Sine.easeInOut
        }).to(this.$done,.3, {
            delay : 1.3,
            scale : .7,
            opacity:0,
            display:'none',
            ease : Sine.easeInOut
        }).set(this.$splash, {
            display:'none',
        });

    }
    render(){
        this.status.progress = document.querySelector('.pace-progress').getAttribute('data-progress');
        this.$now.innerText = this.status.progress;
    }
    resize(_displayType){
        let _w = window.innerWidth;
        let _h = window.innerHeight;
        if(_displayType == 'sp'){
            TweenMax.set(['#l-splash-hello-bg-sp','#l-splash-hello-text-sp'],{
                width:_w,
                height:_w*2.133,
                x:0,
                y:-((_w*2.133-_h)/2)
            });
        }else{
            if(_w>_h){
                TweenMax.set(['#l-splash-hello-bg','#l-splash-hello-text'],{
                    width:_w,
                    height:_w,
                    x:0,
                    y:-((_w-_h)/2)
                });
            }else{
                TweenMax.set(['#l-splash-hello-bg','#l-splash-hello-text'],{
                    width:_h,
                    height:_h,
                    x:-((_h-_w)/2),
                    y:0
                });
            }
        }
    }
}